import navChannel from '@/nav/channel'

export const init = function (event: string): void {
  navChannel.trigger(`sideNav:${event}`)
}
